import { createFileRoute, redirect } from '@tanstack/react-router';

import { getCurrentSession } from '../app/auth-state';
import { OPERATOR_ROLE } from '../modules/auth/domain/entities/session';
import { LoginPage } from '../modules/auth/ui/pages/LoginPage';

export const Route = createFileRoute('/login')({
  beforeLoad: () => {
    const session = getCurrentSession();
    if (session?.user.role === OPERATOR_ROLE) {
      throw redirect({ to: '/queue' });
    }
  },
  component: LoginPage,
});
